import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { LocationDetailsSession } from '../../api/models/locationDetailsSession';
import { PlacardCatalogResponse } from '../../api/models/placardCatalog';
import { PlacardDetailsSession } from '../../api/models/placardDetailsSession';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, CONTINENTAL_REGIONS, RouteURLConstants, ServiceURLConstants, UTagConstants } from '../../constants/upplm.constants';
import { PLACARD_CATALOGS } from '../../constants/upplm.constants.placardcatalog';
import { KeyValue, PlacardOptionsResponse } from '../../interface/upplm.placard';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { PlacardCatalogService } from '../../services/upplm.placardCatalog.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UtagService } from '../../services/upplm.utag.service';

@Component({
    selector: 'placarddetails',
    template: require('./placardDetails.component.html'),
    providers: [PlacardCatalogService]
})

export class PlacardDetailsComponent implements OnInit, AfterViewInit {
    sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    public isLoadding: boolean = false;
    public isInitialLoadding: boolean = true;
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    togglePlacard: boolean = false;
    placardInformations: PlacardOptionsResponse;
    public placardTypekey: string;
    public placardSizeKey: string;
    Errors: any[];
    shipmentType: KeyValue[] = [];
    desiredPlacardSize: KeyValue[] = [];
    globalRegionCountry: string = 'NA';
    selectedCountry: string = 'US';

    constructor(private router: Router,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService,
        private _pbService: ProgressBarService,
        private _utagService: UtagService,
        private _translateData: TranslateDataPipe,
        private _placardCatalogService: PlacardCatalogService) { }

    ngOnInit() {
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_PLACARD_DETAILS_START, UTagConstants.UPPLM_PLACARD_DETAILS_START_SCREEN);
        this.isInitialLoadding = true;
        this.globalRegionCountry = this._commonService.getRegionCountry(this._sessionService.sessionData.locationDetails.countryKey);
        this.getPlacardOptions();
        this.placardTypekey = "01";
        this.placardSizeKey = "01";
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false)).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;
                this._sessionService.mapSessionResponse(response);
                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocation();
                }
                if (this.sessionData.placardDetails) {
                    this.globalRegionCountry = this._commonService.getRegionCountry(this.sessionData.locationDetails.countryKey);
                    this.bindDataFromSession(this.sessionData.placardDetails);
                }
            }
            else {
                this.SessionErrorModal.open();
            }
            this.isInitialLoadding = false;
        });
    }

    goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        if (update) {
            let data: PlacardDetailsSession = new PlacardDetailsSession();
            data.togglePlacard = this.togglePlacard;
            data.placardTypekey = this.placardTypekey;
            data.placardSizeKey = this.placardSizeKey;
            request.placardDetails = data;
        }
        else {
            request.placardDetails = this.sessionData.placardDetails;
        }
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        this._pbService.pb.showStatusBar = this.pbDetails.showStatusBar;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    bindDataFromSession(data: PlacardDetailsSession) {
        this.togglePlacard = data.togglePlacard;
        this.placardSizeKey = data.placardSizeKey;
        this.placardTypekey = data.placardTypekey;
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateData.transform('upplm.common.sessiontimedouttitle')
        });
        this.SessionErrorModal.setProperties({
            title: this._translateData.transform('upplm.common.serviceerror')
        }); 
    }

    nextPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.displayErrors();
            if (this.Errors.length == 0) {
                this._pbService.pb = new ProgressBarDetails();
                this._pbService.pb.locationPB = "true";
                this._pbService.pb.contactPB = "true";
                this._pbService.pb.placardPB = "true";
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PICKUP_DETAILS_ROUTE);
            }
        }
    }

    saveGoReviewPage() {
        this.Errors = null;
        this.displayErrors();
        if (this.Errors.length == 0) {
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
        }
    }

    cancelGoReviewPage() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();            
            this.ConfirmationBoxModal.open();
        }
        else {
            this.isLoadding = true;
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true)).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    displayErrors() {
        this.Errors = [];
    }

    backPage() {
        this._pbService.pb = new ProgressBarDetails();
        this._pbService.pb.locationPB = "true";
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_CONTACT_DETAILS_ROUTE);
    }

    getPlacardOptions() {
        this.isLoadding = true;
        this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_PLACARD_OPTIONS, ApiErrorCode.GET_PLACARD_OPTIONS), null).subscribe((response: PlacardOptionsResponse) => {
            this.placardInformations = response;
            this.shipmentType = this.translateShipmentType(response.placardType);
            this.getPlacardSize();
            this.isLoadding = false;
        });
    }

    async getPlacardSize() {
        this.desiredPlacardSize = [];
        let placardSizes: KeyValue[] = [];
        const response: PlacardCatalogResponse = await this._placardCatalogService.getPlacardCatalog(PLACARD_CATALOGS.PLACARD_SIZE, this.sessionData.locationDetails.countryKey);
        if (!response.errors && response.catalogs.length > 0) {
            response.catalogs[0].elements.forEach(element => {
                let size = {
                    key : element.key,
                    value : element.value
                } as KeyValue;
                placardSizes.push(size);
            })
        }
        this.desiredPlacardSize = this.globalRegionCountry === CONTINENTAL_REGIONS.NA ? this._placardCatalogService.getPlacardSizeByKeyValue(placardSizes) : placardSizes;
    }

    translateShipmentType(shipmentTypes: KeyValue[]): KeyValue[] {
        let translatedShipments: KeyValue[] = [];
        shipmentTypes.forEach(shipmentType => {
            let keyvalue = new KeyValue();
            keyvalue.value = shipmentType.value === 'LAB SPECIMEN' ? this._translateData.transform('upplm.placarddetails.labspecimen').toUpperCase() :
                this._translateData.transform('upplm.placarddetails.nonlab').toUpperCase();
            keyvalue.key = shipmentType.key;
            translatedShipments.push(keyvalue);
        });
        return translatedShipments;
    }
}